// Service Interfaces
// Centralized interface definitions for all service-related functionality

import { ApiResponse } from './common';

// ===== API SERVICE INTERFACES =====

// Request tracking for duplicate prevention
export interface PendingRequest {
  url: string;
  method: string;
  cancelToken: any; // CancelTokenSource from axios
  timestamp: number;
}

// ===== SESSION MANAGER INTERFACES =====

export interface CacheItem<T> {
  data: T;
  timestamp: number;
  ttl: number; // Time to live in milliseconds
}

// Cache keys constants
export const CACHE_KEYS = {
  CUSTOMERS: 'customers',
  PRODUCTS: 'products',
  INVOICES: 'invoices',
  USERS: 'users',
  NEXT_INVOICE_NUMBER: 'next_invoice_number'
} as const;

// ===== HOOK INTERFACES =====

export interface UseDataManagerOptions<T> {
  searchFields: (keyof T)[];
  defaultPage?: number;
  defaultLimit?: number;
  defaultSortBy?: keyof T;
  defaultSortOrder?: 'asc' | 'desc';
}

export interface UseDataManagerReturn<T> {
  // Data
  allData: T[];
  filteredData: T[];
  paginatedData: {
    data: T[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
  
  // Filter state
  filters: {
    search?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    page?: number;
    limit?: number;
    [key: string]: any;
  };
  setFilters: (filters: any) => void;
  updateFilter: (key: string, value: any) => void;
  clearFilters: () => void;
  
  // Loading state
  loading: boolean;
  setLoading: (loading: boolean) => void;
  error?: string | null;
  
  // Actions
  refreshData: () => void;
  exportData: (filename?: string) => void;
}

export interface ApiCallInfo {
  url: string;
  method: string;
  timestamp: number;
  status: 'pending' | 'completed' | 'cancelled' | 'error';
  duration?: number;
}

export interface UseApiMonitorReturn {
  apiCalls: ApiCallInfo[];
  pendingCount: number;
  clearHistory: () => void;
  getStats: () => {
    total: number;
    pending: number;
    completed: number;
    cancelled: number;
    errors: number;
    averageDuration: number;
  };
} 